<template>
 <v-dialog :title="isMismatch?'불일치 사유':'승인거부 사유'" v-model="rejectDialog" persistent max-width="600px">
    <v-row no-gutters align="center" justify="center">
      <v-card v-if="isMismatchForm" id="popStyle02">
        <v-card-text>
          <v-form ref="messageForm" v-model="valid">
            <number-text-field
              v-model="mismatchAmount"
              label="불일치 잔액 입력"
              suffix="원"
              outlined
              :rules="numberRules"
              >
            </number-text-field>
            <v-text-field
              class="inputH48_01 W100 H2row"
              v-model="rejectMessage"
              label="불일치 사유"
              outlined
              rows="1"
              no-resize
              :rules="dataRules"
              @keyup.enter="rejectMsg"
              :maxlength="messageMaxlegnth"
              counter
            ></v-text-field>
          </v-form>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text class="" v-on:click="rejectMsg">확인</v-btn>
          <v-btn text v-on:click="close">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
      <v-card v-else id="popStyle02">
        <v-card-text>
            <v-text-field class="inputH48_01 W100 H2row" v-model="rejectMessage"
              :label="isMismatch?'불일치 사유':'승인거부 사유'"
              :placeholder="isMismatch?'불일치 사유를 입력해주세요.':'승인거부 사유를 입력해주세요.'"
              outlined
              rows="2"
              no-resize
              @keyup.enter="rejectMsg"
              :rules="rejectMsgRules"
              :maxlength="messageMaxlegnth"
              counter
            ></v-text-field>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text class="" v-on:click="rejectMsg">확인</v-btn>
          <v-btn text v-on:click="rejectDialog = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
      <s-confirm ref="confirm"></s-confirm>
    </v-row>
  </v-dialog>
</template>
<script>
import NumberTextField from '@/components/numberTextField'
export default {
  name: 'rejectDialog',
  components: {
    NumberTextField
  },
  filters: {
  },
  props:{
    ctrNumber: String,
    isMismatchForm: Boolean,
    formCode: String,
  },
  data () {
    return {
      rejectDialog : false,
      mismatchAmount: 0,
      rejectMessage : '',
      messageMaxlegnth: 200,
      dataRules: [
        v => !!v || '불일치 사유를 입력해주세요.',
        v => v.length <= this.messageMaxlegnth || '불일치 사유 최대 입력길이는 ' + this.messageMaxlegnth + '자까지 입니다.',
        v => /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|."' |*]+$/.test(v) || '., ", \'를 제외한 특수문자는 사용이 불가능합니다.'
      ],
      rejectMsgRules: [
        v => !!v || '거부 사유를 입력해주세요.',
        v => v.length <= this.messageMaxlegnth || '거부 사유 최대 입력길이는 ' + this.messageMaxlegnth + '자까지 입니다.',
        v => /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|."' |*]+$/.test(v) || '., ", \'를 제외한 특수문자는 사용이 불가능합니다.'
      ],
      numberRules: [
        v => !!v || '불일치 잔액을 입력해주세요.',
        v => /[0-9]/g.test(v) || '불일치 잔액은 숫자만 입력해주세요.',
        v => (parseInt(v.replace(/,/gi, "")) > -10000000000 && parseInt(v.replace(/,/gi, "")) < 10000000000) || '불일치 잔액은 -9,999,999,999 ~ 9,999,999,999 사이 값만 입력할 수 있습니다.'
      ],
      valid: false,
      isMismatch: false
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open () {
      this.rejectDialog = true
    },
    rejectMsg () {
      if (this.isMismatchForm) {
        if (this.$refs.messageForm.validate()) {
          const message = this.mismatchAmount + '{#}' + this.rejectMessage
          this.rejectDialog = false
          this.$emit('rejectEvent', message)
        }
      } else {
        this.rejectMessage = this.rejectMessage.trim()
        console.log('this.rejectMessage',this.rejectMessage);
        if (this.rejectMessage) {
          this.rejectDialog = false
          this.$emit('rejectEvent', this.rejectMessage)
        }else{
          this.$refs.confirm.open('alert', '승인거부 사유', '거부사유를 입력해주세요.')
        }
      }
    },
    close () {
      this.$refs.messageForm.reset()
      this.rejectDialog = false
    },
    isMismatchFormCode () {
      if (this.formCode === 'FD01' || this.formCode === 'FD02' || this.formCode === 'FD03') {
        this.isMismatch = true
      }
    }
  }
}
</script>
<style scoped>
</style>
